import { MembershipsBadgesApiClient } from '@fourthwall/services/dist/MembershipsBadgesApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDisableMemberStreakBadgeMutation = createMutationHook(
  MembershipsBadgesApiClient.disableMemberStreakBadge,
  {
    mutationKey: ['disableMemberStreakBadge'],
  },
)
